import {keepPreviousData, useQuery} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient'
import {httpGetMailBatchDetail, HttpGetMailBatchDetailParams} from '@/features/mailer/http/mailer.http'

// Same freshness policy as useMailBatches: refetch on every modal open and
// poll while the visible page still has recipients in coda.
export const useMailBatchDetail = (params: HttpGetMailBatchDetailParams, {enabled = true}: {enabled?: boolean} = {}) =>
    useQuery({
        queryKey: [QUERY_KEYS.MAILER_BATCH_DETAIL, params],
        queryFn: () => httpGetMailBatchDetail(params),
        enabled,
        placeholderData: keepPreviousData,
        staleTime: 0,
        refetchInterval: query => (query.state.data?.data.some(log => log.status === 'pending') ? 5000 : false)
    })
